import React from "react";
import { Box, Typography } from "@mui/material";

export default function ReleasedTextsHeader() {
  const labelSx = {
    fontFamily: '"Globotipo Text Bold", sans-serif',
    color: "#43444e",
    fontSize: "12px",
    textTransform: "uppercase",
    paddingTop: "4px",
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        height: "34px",
        px: "24px",
        mb: "1px",
      }}
    >
      {/* .type */}
      <Typography
        sx={{
          ...labelSx,
          minWidth: "300px",
        }}
      >
        Nº DO BLOCO
      </Typography>

      {/* .version */}
      <Typography
        sx={{
          ...labelSx,
          width: "160px",
          mr: "66px",
          textAlign: "center",
        }}
      >
        CAPÍTULOS
      </Typography>

      {/* .fileComment */}
      <Typography
        sx={{
          ...labelSx,
          width: "180px",
          textAlign: "center",
        }}
      >
        LIBERAÇÃO PLANEJADA
      </Typography>

      {/* .receivedAt */}
      <Typography
        sx={{
          ...labelSx,
          width: "150px",
          mr: "140px",
          textAlign: "center",
        }}
      >
        LIBERADO EM
      </Typography>

      {/* espaço da coluna download */}
      <Box sx={{ width: "25px" }} />
    </Box>
  );
}
